import React from 'react';

import {
  useShareLookalikeAudience,
  useDeleteLookalikeAudience,
} from 'scenes/CustomAudiences/LookalikeAudiences/data/mutations';
import Actions from './Actions';

export default ({
  actions,
  data,
  onDelete,
  limit = 2,
  withShare = true,
  onShowModal,
}) => {
  const [shareLookalikeAudience] = useShareLookalikeAudience({
    showModal: onShowModal,
  });
  const [deleteLookalikeAudience] = useDeleteLookalikeAudience();

  const handleShare = async () => {
    await shareLookalikeAudience(data);
  };

  const handleDelete = async () => {
    await deleteLookalikeAudience(data);
    onDelete?.(data);
  };

  return (
    <Actions
      withShare={withShare}
      limit={limit}
      actions={actions}
      onShare={handleShare}
      onDelete={handleDelete}
    />
  );
};
